<template>
    <div class="bgFxQW">
        <img src="../../assets/images/sea-418742.jpg"
             alt="Đặt vé xe limousine"
             class="jUOtsM">
        <div class="kjFqFd">
            <div class="bGqzvX">
                <h1 class="hoUnZO">Góp phần cho hành trình của bạn hạnh phúc hơn</h1>
                <div class="dbtGmv">
                    <div>
                        <div class="jkwiLX">
                            <div class="ant-row-flex">
                                <div class="fIqoKh ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-19">
                                    <div class="ant-row-flex">
                                        <div class="epOKdU ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-6 md-mb-8">
                                            <div class="jXJBhl">
                                                <div class="ghBeQA">
                                                    <div class="gZRXuM">
                                                        <img src="../../assets/images/location.svg" alt="">
                                                    </div>
                                                    <selector-region ref="selectFrom" v-model="from" :placeholder="'Nhập nơi đi'"></selector-region>
                                                </div>
                                            </div>
                                            <div @click="swap" class="fYpVyH d-md-n">
                                                <img src="../../assets/images/swap.svg" alt="">
                                            </div>
                                            <div class="jsdFhZ d-md-n"></div>
                                        </div>
                                        <div class="erewyu ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-6 md-mb-8">
                                            <div class="kyXtnm">
                                                <div class="ghBeQA">
                                                    <div class="gZRXuM">
                                                        <img src="../../assets/images/location.svg" alt="">
                                                    </div>
                                                    <selector-region ref="selectTo" v-model="to" :placeholder="'Nhập nơi đến'" :is-from="false"></selector-region>
                                                </div>
                                                <div class="jsdFhZ d-md-n"></div>
                                            </div>
                                        </div>
                                        <div class="fAGyPa ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-6 md-mb-8">
                                            <div class="kyXtnm">
                                                <div class="ghBeQA">
                                                    <div class="gZRXuM">
                                                        <img src="../../assets/images/bus-icon.svg" alt="">
                                                    </div>
                                                    <selector-vehicle-category ref="selectVehicle" v-model="queryParams.vehicle_category_id"></selector-vehicle-category>
                                                </div>
                                                <div class="jsdFhZ d-md-n"></div>
                                            </div>
                                        </div>
                                        <div class="krWMaZ ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-6 md-mb-8">
                                            <div class="ftSWJG">
                                                <span class="dFcWyt ant-input-affix-wrapper">
                                                    <span class="ant-input-prefix">
                                                        <img src="../../assets/images/datepicker.svg" alt="">
                                                    </span>
                                                    <custom-datepicker ref="selectTime" v-model="queryParams.from_time" :placeholder="'Nhập ngày đi'"></custom-datepicker>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ksaiWq ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-5">
                                    <div class="encbDi">
                                        <button type="button" class="ant-btn eJOMls ant-btn-block" @click.stop="submit">
                                            <span>Tìm vé xe</span>
                                        </button>
                                    </div>
                                </div>
                                <div @click="swap" class="fxmhwz d-lg-none">
                                    <img class="gMJebn" src="../../assets/images/swap-mobile.svg" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { SelectorRegion, CustomDatepicker, SelectorVehicleCategory } from "../shared/components";
    import {MixinHelper} from "../shared/services";
    import {required, minValue} from "vuelidate/lib/validators"
    import {EXCEPT_PROVINCES, HCROUTES} from "../shared/constants/Constant";

    export default {
        name: "HomePage",
        mixins: [MixinHelper],
        components: {
            SelectorVehicleCategory,
            CustomDatepicker,
            SelectorRegion,
        },
        created() {
            const dataLocalStorage = this.retrieveData('params');
            const from = this.getProp(dataLocalStorage, 'from', null);
            const to = this.getProp(dataLocalStorage, 'to', null);

            if (Object.values(EXCEPT_PROVINCES).includes(this.getProp(from, 'id')) || Object.values(EXCEPT_PROVINCES).includes(this.getProp(to, 'id'))) {
                this.removeData('params');
            } else {
                this.from = from;
                this.to = to;
            }
            this.queryParams.vehicle_category_id = this.getProp(dataLocalStorage, 'vehicle_category_id', 0);
            this.queryParams.from_time = (new Date()).valueOf();
        },
        data() {
            return {
                from: null,
                to: null,
                queryParams: {
                    vehicle_category_id: 0,
                    from_time: 0,
                    from_district: 0,
                    to_district: 0,
                    from_province: 0,
                    to_province: 0,
                }
            };
        },
        validations: {
            from: {
                required
            },
            to: {
                required
            },
            queryParams: {
                // vehicle_category_id: {
                //     minValue: minValue(1)
                // },
                from_time: {
                    minValue: minValue(1)
                },
            }
        },
        methods: {
            swap() {
                const temp = this.to;
                this.to = this.from;
                this.from = temp;
            },
            submit() {
                this.$v.from.$touch();
                if (this.$v.from.$pending || this.$v.from.$error) {
                    this.$refs.selectFrom.openDropDown();
                    return;
                }

                this.$v.to.$touch();
                if (this.$v.to.$pending || this.$v.to.$error) {
                    this.$refs.selectTo.openDropDown();
                    return;
                }

                // this.$v.queryParams.vehicle_category_id.$touch();
                // if (this.$v.queryParams.vehicle_category_id.$pending || this.$v.queryParams.vehicle_category_id.$error) {
                //     this.$refs.selectVehicle.select();
                //     return;
                // }

                this.$v.queryParams.from_time.$touch();
                if (this.$v.queryParams.from_time.$pending || this.$v.queryParams.from_time.$error) {
                    this.$refs.selectTime.openCalendar();
                    return;
                }
                const p = {
                    ...{},
                    from: this.from,
                    to: this.to,
                    vehicle_category_id: this.queryParams.vehicle_category_id,
                    from_time: this.queryParams.from_time
                };
                this.storeData('params', p);
                this.$router.push({name: HCROUTES.schedule, query: this.filterParams(this.queryParams)})
            }
        },
        watch: {
            from(val) {
                if (val) {
                    if(val && val._province_id !== undefined && val._province_id !== null) {
                        this.queryParams.from_district = val.id;
                        this.queryParams.from_province = 0;
                    } else {
                        this.queryParams.from_province = val.id;
                        this.queryParams.from_district = 0;
                    }
                }
            },
            to(val) {
                if (val) {
                    if(val._province_id !== undefined && val._province_id !== null) {
                        this.queryParams.to_district = val.id;
                        this.queryParams.to_province = 0;
                    } else {
                        this.queryParams.to_province = val.id;
                        this.queryParams.to_district = 0;
                    }
                }
            },
        },
    }
</script>

<style scoped>
    @import "../../assets/css/antd.css";
</style>
<style>

    .bgFxQW {
        width: 100%;
        height: calc(100vh - 60px);
        position: relative;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        z-index: 1;
        transition: all 200ms ease 0s;
    }

    .jUOtsM {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        top: 0px;
        left: 0px;
        bottom: 0px;
        right: 0px;
    }

    img {
        vertical-align: middle;
        border-style: none;
    }

    .kjFqFd {
        position: relative;
        width: 1200px;
        height: 100%;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
    }

    .bGqzvX {
        width: 100%;
    }

    .hoUnZO {
        font-size: 38px;
        font-weight: 500;
        margin-bottom: 22px;
        color: white;
        text-align: center;
    }

    .dbtGmv {
        width: 100%;
    }

    .jkwiLX {
        max-width: 1366px;
        position: relative;
        width: 100%;
        margin: auto;
        background: rgba(255, 255, 255, 0.64);
        border-radius: 5px;
    }

    .fIqoKh {
        position: relative;
    }

    .epOKdU {
        z-index: 4;
    }

    .jXJBhl {
        position: relative;
    }

    .ghBeQA {
        position: relative;
    }

    .gZRXuM {
        color: rgb(0, 122, 255);
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 24px;
        z-index: 2;
    }

    svg:not(:root) {
        overflow: hidden;
    }

    .epOKdU input {
        border-radius: 3px 0px 0px 3px;
    }

    .erewyu input{
        border-radius: 0px;
    }
    .fAGyPa input {
        border-radius: 0px;
    }

    button, input {
        overflow: visible;
    }

    .fYpVyH {
        z-index: 4;
        right: 0px;
        top: 50%;
        transform: translate(50%, -50%);
        cursor: pointer;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        position: absolute;
        background: white;
    }

    .jsdFhZ {
        width: 1px;
        height: 37px;
        position: absolute;
        right: 0px;
        top: 16px;
        background: rgb(187, 187, 187);
    }

    .erewyu {
        z-index: 3;
    }

    .fAGyPa {
        z-index: 2;
    }

    .kyXtnm {
        position: relative;
    }

    .kyXtnm .VXRSelect__input {
        padding-left: 72px;
    }

    .krWMaZ {
        z-index: 1;
    }

    .ftSWJG {
        position: relative;
    }

    .jkwiLX .ant-input-affix-wrapper .ant-input-prefix {
        left: 22px;
    }

    .dFcWyt input {
        height: 48px;
        outline: none;
        background: rgb(255, 255, 255);
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        border-radius: 0px;
    }

    .jkwiLX .ant-input-affix-wrapper input {
        border-color: rgb(228, 228, 228);
        border-radius: 0px;
    }

    .jkwiLX .ant-input-affix-wrapper > input:not(:first-child) {
        padding-left: 58px;
        font-size: 20px;
        color: rgb(102, 102, 102);
    }

    .ksaiWq {
        -webkit-box-flex: 1;
        flex-grow: 1;
    }

    .encbDi {
        text-align: center;
    }

    .eJOMls {
        height: 68px;
        color: rgb(72, 72, 72);
        text-transform: uppercase;
        font-weight: bold;
        font-size: 20px;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        border-radius: 0px 3px 3px 0px;
        background: rgb(255, 197, 0);
    }

    .eJOMls:hover, .eJOMls:focus {
        background: rgb(255, 197, 0);
        color: rgb(72, 72, 72);
    }

    .faoMZh path {
        fill: rgb(24, 97, 197);
    }

    .fxmhwz {
        height: 44px;
        width: 44px;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        position: absolute;
        right: 18px;
        top: 30px;
        border-radius: 22px;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(228, 228, 228);
        border-image: initial;
        background: white;
        z-index: 10;
    }

    .gMJebn {
        width: 20px;
        height: auto;
    }

    .svg-exchange {
        fill: #5090e9;
    }

    @media (min-width: 576px) {
        .eJOMls {
            height: 68px;
        }

        .dFcWyt input {
            height: 68px;
        }

        .jXJBhl .VXRSelect__input {
            height: 68px;
        }

        .kyXtnm .VXRSelect__input {
            height: 68px;
        }

        .vdp-datepicker input {
            height: 68px;
        }

    }

    @media (min-width: 992px) {
        .d-lg-none {
            display: none;
        }

        .ghBeQA .v-select {
            border-radius: 3px 0px 0px 3px;;
        }
    }

    @media (min-width: 1200px) {
        .epOKdU {
            margin: 0px;
        }

        .erewyu {
            margin: 0px;
        }

        .fAGyPa {
            margin: 0px;
        }

        .ksaiWq {
            margin: 0px;
        }

        .krWMaZ {
            margin: 0px;
        }

        .bGqzvX {
            margin-top: -150px;
        }

        .kyXtnm div div {
            left: 30px;
        }
        input.vs__search {
            padding-left: 60px;
        }
        .vs__selected {
            padding-left: 60px;
        }
    }

    @media (min-width: 992px) and (max-width: 1199px){
        .logo {
            margin-left: 36px;
        }
        .kjFqFd {
            padding: 94px 36px 28px;
        }
    }


    @media (max-width: 991px) {
        .kyXtnm > div > div {
            left: 24px;
        }

        .kyXtnm .VXRSelect__input {
            padding-left: 58px;
        }

        .fYpVyH {
            right: 24px;
        }

        .hoUnZO {
            font-size: 24px;
            margin-bottom: 50px;
        }

        .md-mb-8 {
            margin-bottom: 8px;
        }

        .kjFqFd {
            padding: 94px 36px 28px;
            align-items: start;
        }

        .jkwiLX {
            background: unset;
        }

        .fIqoKh input {
            border-radius: 3px !important;
        }

        .d-md-n {
            display: none;
        }

        .jkwiLX .ant-input-affix-wrapper > input:not(:first-child) {
            font-size: 16px;
        }

        .ksaiWq {
            margin-top: 8px;
        }

        .eJOMls {
            border-radius: 3px !important;
            font-size: 18px;
        }

        .fxmhwz {
            top: 50px;
        }

        .vdp-datepicker input {
            font-size: 16px;
            border-radius: 3px !important
        }

        .vs__selected {
            font-size: 16px;
        }

        .v-select {
            border-radius: 3px;
        }

        .vs__search {
            font-size: 16px;
        }
    }

    @media (max-width: 575px) {
        .jXJBhl .VXRSelect__input {
            height: 48px;
        }

        .kyXtnm .VXRSelect__input {
            height: 48px;
        }

        .eJOMls {
            height: 48px;
            font-size: 16px;
        }

        .fxmhwz {
            top: 32px;
            height: 36px;
            width: 36px;
        }

        .gMJebn {
            width: 16px;
        }

        .vs__search {
            height: 48px;
        }

        .kjFqFd {
            padding: 94px 16px 28px;
        }
    }

</style>
